import { Language } from '@mui/icons-material';
import { Menu, MenuItem } from '@mui/material';
import NavigationInternalButton from 'features/navigation/ui/Navigation/NavigationInternalButton';
import { useState } from 'react';
import { useI18nLanguage } from 'shared/hooks';
import { localesMap } from 'shared/i18n';


const languageNamesMap = Object.entries(localesMap).reduce((acc, [ langCode, { languageName, languageAbbr } ]) => {
    if (!Object.values(acc).some(([ name, abbr ]) => name === languageName && abbr === languageAbbr)) {
        acc[langCode] = [ languageName, languageAbbr ];
    }

    return acc;
}, {} as Record<string, [ string, string ]>);

interface LanguageSwitchProps {
    compact?: boolean;
}

export default function LanguageSwitch({ compact }: LanguageSwitchProps) {
    const [ language, setLanguage ] = useI18nLanguage();
    const [ anchorEl, setAnchorEl ] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLanguageChange = (langCode: string) => {
        setLanguage(langCode);
        handleClose();
    };

    return (
        <>
            <NavigationInternalButton onClick={ handleClick }
                startIcon={ <Language fontSize="small" /> }>
                { languageNamesMap[language][ compact ? 1 : 0 ] }
            </NavigationInternalButton>
            <Menu
                id="language-select-menu"
                anchorEl={ anchorEl }
                open={ open }
                onClose={ handleClose }
                slotProps={{
                    paper: {
                        sx: { minWidth: '180px' }
                    }
                }}
            >
                { Object.entries(languageNamesMap).map(([ langCode, [ langName, langAbbr ] ]) => (
                    <MenuItem key={ langCode }
                        selected={ langCode === language }
                        onClick={ () => handleLanguageChange(langCode) }
                    >
                        { compact ? langAbbr : langName }
                    </MenuItem>
                )) }
            </Menu>
        </>
    );
}
